// src/components/Enrollments/components/EnrollmentsRow.jsx
// ============================================================================
// BLOCK ENR.ROW.0 — Single enrollments report row
// ----------------------------------------------------------------------------
// PURPOSE
//  - Keep row rendering isolated so column formatting changes are easy later.
// ============================================================================

import React from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { COLUMN_DEFINITIONS } from '../constants/enrollmentsUi.js';

function formatCellValue(key, value) {
  if (key === 'year') {
    return value || '';
  }

  if (key.startsWith('m') || key === 'total') {
    return Number(value || 0).toLocaleString();
  }

  return value || '';
}

function EnrollmentsRow({ row }) {
  return (
    <TableRow hover data-cy="enrollments-row">
      {COLUMN_DEFINITIONS.map((column) => (
        <TableCell key={column.key} align={column.align} sx={{ whiteSpace: 'nowrap' }}>
          {formatCellValue(column.key, row[column.key])}
        </TableCell>
      ))}
    </TableRow>
  );
}

export default React.memo(EnrollmentsRow);
